import CALLBACK_IDS from '../enums/callbackIds';

export default function getCallbackId(routeName) {
  return CALLBACK_IDS[routeName] || 'common';
}
